import React, { useMemo } from "react";

// Particle burst scaled by rarity. Rendered when `fire` key changes.
export default function Confetti({ fireKey, color = "#8B5CF6", intensity = 1 }) {
  const pieces = useMemo(() => {
    if (!fireKey) return [];
    const count = Math.round(24 * intensity);
    const palette = [color, "#22D3EE", "#EC4899", "#F59E0B", "#ffffff"];
    return Array.from({ length: count }, (_, i) => {
      const ang = Math.random() * Math.PI * 2;
      const dist = (120 + Math.random() * 220) * intensity;
      return {
        id: i,
        tx: Math.cos(ang) * dist,
        ty: Math.sin(ang) * dist - 60,
        rot: (Math.random() * 720 - 360),
        dur: 0.7 + Math.random() * 0.8,
        size: 6 + Math.random() * 8,
        c: palette[Math.floor(Math.random() * palette.length)],
      };
    });
    // eslint-disable-next-line
  }, [fireKey]);

  if (!fireKey) return null;
  return (
    <div className="pointer-events-none absolute inset-0 z-30 flex items-center justify-center overflow-visible">
      {pieces.map((p) => (
        <span key={p.id} className="confetti-piece absolute rounded-[2px]"
          style={{
            width: p.size, height: p.size * 0.5, background: p.c,
            "--tx": `${p.tx}px`, "--ty": `${p.ty}px`, "--rot": `${p.rot}deg`, "--dur": `${p.dur}s`,
          }} />
      ))}
    </div>
  );
}
